/* getFilterToolbarItems.ts */

/* Components */
import ChipItem from "src/components/insights/filter-toolbar/chip-item/ChipItem";
import DropdownMenu from "src/components/insights/filter-toolbar/dropdown-menu/DropdownMenu";
import CohortDropdown from "src/components/insights/filter-toolbar/dropdown-menu/cohort-dropdown/CohortDropdown";
import TimePeriodDropdown from "src/components/insights/filter-toolbar/dropdown-menu/time-period-dropdown/TimePeriodDropdown";

/* Interfaces */
import {
  FilterType,
  InsightsFilterProps,
} from "src/shared/interfaces/insights-filter/InsightsFilter";

import {
  DropdownMenuProps,
  ChipItemProps,
} from "src/shared/interfaces/common/QuickFilter";

import { CustomCohortsState } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

const disableInsightsFilter = (
  key: FilterType,
  insightsFilterState: InsightsFilterProps
) => {
  const { value, initialValue } =
    insightsFilterState[key] || {};
  return value === initialValue;
};

export const getFilterToolbarItems = (
  insightsFilterState: InsightsFilterProps,
  customCohortsState: CustomCohortsState
): (ChipItemProps | DropdownMenuProps)[] => {
  if (!insightsFilterState || !customCohortsState)
    return [];

  const disableTimePeriod =
    insightsFilterState.timePeriod?.value?.firstYear ===
      insightsFilterState.timePeriod?.initialValue
        ?.firstYear &&
    insightsFilterState.timePeriod?.value?.lastYear ===
      insightsFilterState.timePeriod?.initialValue
        ?.lastYear;

  const customCohortDisabled =
    customCohortsState.customCohortsByDisease[
      customCohortsState.currentDiseaseId!
    ]?.cohorts?.length === 0;

  return [
    {
      filterKey: FilterType.MAIN_CONDITION,
      component: ChipItem,
      value: insightsFilterState.mainCondition.value!,
      initialValue:
        insightsFilterState.mainCondition.initialValue!,
      show: true,
      disabled: disableInsightsFilter(
        FilterType.MAIN_CONDITION,
        insightsFilterState
      ),
    },
    {
      filterKey: FilterType.FEATURES,
      component: ChipItem,
      value: insightsFilterState.features.value!,
      initialValue:
        insightsFilterState.features.initialValue!,
      show: !insightsFilterState.features.disabled,
      disabled: disableInsightsFilter(
        FilterType.FEATURES,
        insightsFilterState
      ),
    },
    {
      filterKey: FilterType.COHORTS,
      component: ChipItem,
      value: insightsFilterState.cohorts.value!,
      initialValue:
        insightsFilterState.cohorts.initialValue!,
      show: true,
      disabled: disableInsightsFilter(
        FilterType.COHORTS,
        insightsFilterState
      ),
    },
    {
      component: DropdownMenu,
      children: TimePeriodDropdown,
      label: "Time period",
      show: true,
      disabled: disableTimePeriod,
    },
    {
      component: DropdownMenu,
      children: CohortDropdown,
      label: "Custom Cohorts",
      show: !customCohortDisabled,
      disabled: customCohortDisabled,
    },
  ];
};
